import { FC } from 'react';
import {LinkButton} from "../../../shared/components";
import {Typography, Box} from "@mui/material";
import { useLangContext } from 'shared/features/Language';

export const HomeSection03:FC = () => {
  const {textData} = useLangContext();

  return (
    <Box sx={{textAlign: {lg: 'left', xs: 'center'}, marginBottom: {lg: '20px', xs: '10px'}, }}>
      <Typography
        variant='body2'
        sx={{
          marginBottom: {lg: '10px', xs: '5px'},
        }}
      >{textData.homeMotivationGetInstruction}</Typography>
      <LinkButton to='/verify' width={{lg:'480px', xs:'240px'}}>{textData.buttonCaptionGetInstruction}</LinkButton>
    </Box>
  );
}
